import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PageTitleService } from '../services/page-title.service';

@Component({
  selector: 'app-page-title',
  imports: [MatButtonModule, MatIconModule],
  template: `
    @if (title() || action()) {
      <div class="page-title-row">
        <div class="page-title-text">
          @if (title()) {
            <h1 class="title-large primary-color mb-0">{{ title() }}</h1>
          }
          @if (subtitle()) {
            <p class="body-large sub-title-text-color mt-0 mb-0">{{ subtitle() }}</p>
          }
        </div>
        @if (action(); as currentAction) {
          <button mat-stroked-button class="page-title-action" (click)="currentAction.onClick()">
            <mat-icon>{{ currentAction.icon }}</mat-icon>
            {{ currentAction.label }}
          </button>
        }
      </div>
    }
  `,
  styleUrl: './page-title.sass',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTitle {
  private readonly pageTitleService = inject(PageTitleService);
  readonly title = this.pageTitleService.title;
  readonly subtitle = this.pageTitleService.subtitle;
  readonly action = this.pageTitleService.action;
}
